<template>
  <div class="info-list">
    <ul>
      <li
        v-for="(item, index) in itemList1"
        :key="index"
        class="info-list-item"
        :class="{ active: index == isActive }"
        @click="addActive(index, item)"
      >
        <span class="info_title">
          <div class="info_icon">
            <img :src="item.icon" width="100%" height="100%" />
          </div>
          <p>{{ item.title }}</p>
        </span>
        <span class="info_text">{{ item.text }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "infolist",
  props: ["id"],
  data() {
    return {
      isActive: this.$store.state.tabIndex,
      activeName: "first",
      infoList: "",
      uid: this.id,
      itemList1: [
        {
          title: "活动时间",
          icon: "./static/images/icons/time1.png",
          text: ""
        },
        {
          title: "预约时间",
          icon: "./static/images/icons/time2.png",
          text: ""
        },
        {
          title: "活动地点",
          icon: "./static/images/icons/place.png",
          text: "",
          heightflag: true
        },
        {
          title: "适合人群",
          icon: "./static/images/icons/people.png",
          text: ""
        },
        {
          title: "活动人数",
          icon: "./static/images/icons/number.png",
          text: ""
        },
        { title: "联系电话", icon: "./static/images/icons/tel.png", text: "" }
      ]
    };
  },
  mounted() {
    // if(this.isActive != 0){
    // 	this.$router.push(this.itemList[this.isActive].link);
    // };
    this.getitemList();
  },
  methods: {
    // addActive: function(index,item){
    // 	this.isActive = index;
    // 	this.$router.push(item.link);
    // 	this.$store.commit("changeTab",index);
    // },
    getitemList() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl + "/api/activity/web/activity/" + this.uid,
          {}
        )
        .then(response => {
          // console.log(1);
          var result = response.data;
          this.infoList = result.data;
          this.itemList1[0].text =
            result.data.startTime.substring(0, 16) +
            "~" +
            result.data.endTime.substring(0, 16);
          this.itemList1[1].text =
            result.data.apStartTime.substring(0, 16) +
            "~" +
            result.data.apEndTime.substring(0, 16);
          this.itemList1[2].text = result.data.location;
          this.itemList1[3].text = result.data.adaptPeople;
          this.itemList1[4].text = result.data.totalQuantity;
          this.itemList1[5].text = result.data.phoneNumber;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/infoList/infoList.vue